module.exports = __webpack_public_path__ + "img/avt_placeholder.1737f0b6.jpg";